export default {
  enImageStyle: "enImageShow",
  cnImageStyle: "cnImageHide",
  menu : {
     home:"Home",
     appSign:"IOS/APP Super Signature",
     enterpriseSign:"Enterprise Signature",
     aboutUs:"About Us",
  },
  buttons: {
    registerNow: 'SIGN UP',
    loginToPublish: 'LOG IN',
    qqOnline: '24hr Online Support',
  },
  steps: {
    stepsClear:'Simple & Clear Operation Steps',
    cooperation: '1. Cooperation talks',
    uploadAppPackage: '2. Upload APP installation package file',
    signSuccessfully: '3. Signature created',
    recharge: '4. Top up',
    exclusiveLinks: '5. Issue exclusive links'
  },
  adnvantages: {
    fourAdvantages: "The 4 Advantages",
    firstOnNetwork: "The First on Network",
    firstOnNetworkDescription: "Equipped with thousands of Mac Servers. Support large capacity and high concurrent download. Unique signature mechanism. No lose signing or flashback throughout the year. Provide links, QR codes and interfaces. Support own link generation.",
    installAndUse: "Install and Use",
    installAndUseDescription: "No jailbreak needed, no App Store on the shelf, updates are free, no trust operation required. Only have to provide the APP installation package file, and share the link with others.",
    costEeffective: 'Cost-effective',
    costEeffectiveDescription: 'Buy on demand, unused equipment will not expired. Download the same app multiple times on the same device will only charged once. Help you to save a lot from the cost of customer acquisition, signature revokes, operation and maintenance, etc.',
    oneToOne: '1 to 1 Exclusive',
    oneToOneDescription: 'Get your problems solved by an expert one-on-one at anytime. Support independent deployment of private cloud platform services, support customers to download and install on their own pages, and conduct commercial advertising.'
  },
  differences: {
    differentFeaturesPC: 'Features You Love',
    differentFeaturesEN: 'Features You Love',
    differentFeaturesCN1: '',
    differentFeaturesCN2: '',
    difference1: 'Our signature mechanism is different from the traditional signature, the probability of revokes is much lower.',
    difference2: 'Say goodbye to the risk of losing your signature with only pay the customer acquisition fee once.',
    difference3: 'Download and install the app on the same device without limit.',
    difference4: 'Charged according to the number of devices, can be use up to 1 year.',
    difference5: 'Install APP without trust operation and authorization, good user experience.',
    difference6: 'No plug-ins, no backdoors.'
  },
  partners: 'Partners',
  companyName: 'Company Name',
  record: 'Record',
  address: 'Address',
  phone: 'Phone',
  industry: 'Industry',
  industryValue: 'Software company'
}
